import toDate from '../toDate/index';
/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a quarter for the given date.
 *
 * @description
 * Return the start of a quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param date - the original date
 * @returns the start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
export default function startOfQuarter(dirtyDate) {
    const date = toDate(dirtyDate);
    const quarter = date.getMonth() / 3 | 0;
    date.setFullYear(date.getFullYear(), quarter * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}
